import { NoBreadcrumbData, PAGES } from '../types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AiBots = (data: NoBreadcrumbData) => {
  return [
    {
      page: PAGES.AI_BOTS,
      link: `/ai/bots`,
      label: 'AI Bots',
    },
  ];
};
